/* istanbul ignore file */
import { Switch, Route } from 'react-router-dom'
import ClaimMyListing from '../claimMyListing'

import PrivateSellerForm from '../../containers/privateSellerPage/privateSellerForm'
import { sellerFlowPath } from '../sellerFlow/steps'

const Router = () => {
  return (
    <Switch>
      <Route path='/claim-my-listing' exact render={() => <ClaimMyListing />} />

      <Route
        path={`${sellerFlowPath}*`}
        render={props => <PrivateSellerForm {...props} />}
      />
    </Switch>
  )
}

export default Router
